<!--
  Il titolo passa la chiave: lo traduce il drawer quando si apre, come nel pannello delle notifiche.
  Il contenuto nasce alla prima apertura: il pannello sta nella cornice dell'app e, creato all'avvio, le pipe
  `translate` (pure) restavano nella lingua di partenza, cioè in inglese al primo accesso da un browser nuovo
-->
<ape-drawer
  [visible]="visible"
  [title]="TRANSLATION_KEYS.support.TITLE"
  (visibleChange)="onVisibleChange($event)"
  (closeClick)="onVisibleChange(false)"
  [closable]="true"
>
  <div
    *ngIf="contentReady"
    data-testid="support-content"
    class="flex flex-col gap-6 text-gray-black pt-6 border-t border-gray-light"
  >
    <div class="flex flex-col gap-1">
      <!-- Sottotitolo -->
      <h2 class="text-xl font-bold">
        {{ TRANSLATION_KEYS.support.SUBTITLE | translate }}
      </h2>

      <!-- Descrizione -->
      <p class="font-light">
        {{ TRANSLATION_KEYS.support.DESCRIPTION | translate }}
      </p>
    </div>

    <!-- Riferimenti per il supporto -->
    <div>
      <!-- Titolo -->
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.EMAIL_SECTION_TITLE | translate }}
      </div>

      <!-- Descrizione -->
      <p class="font-light py-4 border-b border-gray-light">
        {{ TRANSLATION_KEYS.support.EMAIL_SECTION_DESCRIPTION | translate }}
      </p>

      <!-- Link -->
      <a
        class="flex items-center justify-between h-[54px] border-b border-gray-light relative"
        [href]="'mailto:' + (TRANSLATION_KEYS.support.SUPPORT_EMAIL | translate)"
        target="_blank"
      >
        <span>{{ TRANSLATION_KEYS.support.SUPPORT_EMAIL | translate }}</span>
        <span class="bg-button-primary rounded-[12px] size-8 flex items-center justify-center">
          <svg-icon
            src="assets/icons/send.svg"
            class="w-5 h-5 text-white"
            [applyClass]="true"
          />
        </span>
      </a>
    </div>

    <!-- Performance Management – Guida Pratica: solo testo, come nella piattaforma attuale. Lì il link è
         commentato e punta ancora alla guida di un altro cliente: un URL di Cigierre non c'è -->
    <div>
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.GUIDE_SECTION_TITLE | translate }}
      </div>

      <p class="font-light pt-4">
        {{ TRANSLATION_KEYS.support.GUIDE_SECTION_DESCRIPTION | translate }}
      </p>
    </div>

    <!-- Informativa Privacy Dipendenti: solo testo, come nella piattaforma attuale. Lì il link è commentato
         (percorso di rete interno, non raggiungibile dal browser): un URL di Cigierre non c'è -->
    <div>
      <div class="flex items-center h-[54px] border-b border-gray-light font-bold">
        {{ TRANSLATION_KEYS.support.PRIVACY_SECTION_TITLE | translate }}
      </div>

      <p class="font-light pt-4">
        {{ TRANSLATION_KEYS.support.PRIVACY_SECTION_DESCRIPTION | translate }}
      </p>
    </div>
  </div>
</ape-drawer>